import React, {useEffect} from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import login from "../login/Login";
import Flip from "../flipbook/Flip";
import FlipCliente from "../flipbook/FlipCliente";
import ReactGa from "react-ga";


export default function Routes() {
  
  useEffect(() => {
    ReactGa.initialize('G-3J9X2TJEWP')

    ReactGa.pageview(window.location.pathname + window.location.search)
  }, [])
   
  return (
  
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={login} />
        <Route exact path="/Flipbook" component={Flip} />
        <Route exact path="/FlipbookCliente" component={FlipCliente}   />
        
      </Switch>
    </BrowserRouter>

  );
}
